var _excluded = ["date", "dateFormat", "locale", "onSelect", "renderDay", "weekDayFormat", "dateVisible", "dateEnabled"];

function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

import format from 'date-fns/format';
import enLocale from 'date-fns/locale/en';
import noop from 'lodash.noop';
import React, { useMemo } from 'react';
import Table from "../Table/Table";
import Day from "./components/Day";
import { getVisibleWeeks } from "./util/getVisibleWeeks";
var defaultProps = {
  date: new Date(),
  dateVisible: function dateVisible() {
    return true;
  },
  dateEnabled: function dateEnabled() {
    return true;
  },
  dateFormat: 'D',
  locale: enLocale,
  onSelect: noop,
  weekDayFormat: 'dd'
};

var Calendar = function Calendar(_ref) {
  var _ref$date = _ref.date,
      date = _ref$date === void 0 ? defaultProps.date : _ref$date,
      _ref$dateFormat = _ref.dateFormat,
      dateFormat = _ref$dateFormat === void 0 ? defaultProps.dateFormat : _ref$dateFormat,
      _ref$locale = _ref.locale,
      locale = _ref$locale === void 0 ? defaultProps.locale : _ref$locale,
      _ref$onSelect = _ref.onSelect,
      onSelect = _ref$onSelect === void 0 ? defaultProps.onSelect : _ref$onSelect,
      renderDay = _ref.renderDay,
      _ref$weekDayFormat = _ref.weekDayFormat,
      weekDayFormat = _ref$weekDayFormat === void 0 ? defaultProps.weekDayFormat : _ref$weekDayFormat,
      _ref$dateVisible = _ref.dateVisible,
      dateVisible = _ref$dateVisible === void 0 ? defaultProps.dateVisible : _ref$dateVisible,
      _ref$dateEnabled = _ref.dateEnabled,
      dateEnabled = _ref$dateEnabled === void 0 ? defaultProps.dateEnabled : _ref$dateEnabled,
      props = _objectWithoutProperties(_ref, _excluded);

  var weeks = useMemo(function () {
    return getVisibleWeeks({
      currentDate: date,
      dateVisible: dateVisible,
      dateEnabled: dateEnabled
    });
  }, [date, dateVisible, dateEnabled]);
  return /*#__PURE__*/React.createElement(Table, _extends({
    bordered: false,
    hover: false,
    striped: false
  }, props), /*#__PURE__*/React.createElement("colgroup", null, /*#__PURE__*/React.createElement("col", {
    style: {
      width: '14.29%'
    }
  }), /*#__PURE__*/React.createElement("col", {
    style: {
      width: '14.29%'
    }
  }), /*#__PURE__*/React.createElement("col", {
    style: {
      width: '14.29%'
    }
  }), /*#__PURE__*/React.createElement("col", {
    style: {
      width: '14.29%'
    }
  }), /*#__PURE__*/React.createElement("col", {
    style: {
      width: '14.29%'
    }
  }), /*#__PURE__*/React.createElement("col", {
    style: {
      width: '14.29%'
    }
  }), /*#__PURE__*/React.createElement("col", {
    style: {
      width: '14.29%'
    }
  })), /*#__PURE__*/React.createElement("thead", null, /*#__PURE__*/React.createElement("tr", {
    className: "js-calendar-weekdays"
  }, weeks[0].map(function (day) {
    return /*#__PURE__*/React.createElement("th", {
      key: day.date.toString(),
      className: "text-center"
    }, format(day.date, weekDayFormat, {
      locale: locale
    }));
  }))), /*#__PURE__*/React.createElement("tbody", null, weeks.map(function (days) {
    return /*#__PURE__*/React.createElement("tr", {
      key: days[0].date.toString()
    }, days.map(function (day) {
      return renderDay ? renderDay(day, dateFormat, onSelect, locale) : /*#__PURE__*/React.createElement(Day, {
        "data-testid": "day-".concat(day.date.toDateString()),
        day: day,
        dateFormat: dateFormat,
        key: day.date.toString(),
        locale: locale,
        onClick: function onClick() {
          return day.visible && onSelect(day.date);
        }
      });
    }));
  })));
};

Calendar.displayName = "Calendar";
export default Calendar;